import {
  Analytics as FirebaseAnalytics,
  getAnalytics,
  isSupported,
  logEvent,
  setAnalyticsCollectionEnabled,
} from 'firebase/analytics';
import { deleteApp, FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app';

import { AnalyticsEvent } from './AnalyticsEvent';

export abstract class Analytics {
  private static disabled: boolean = false;

  private static activeFirebase?: {
    app: FirebaseApp;
    analytics: FirebaseAnalytics;
  };

  private static init() {
    console.log('Init Firebase');

    isSupported().then((supported) => {
      console.log('Is Firebase Analytics supported', supported);
    });

    const firebaseConfig: FirebaseOptions = {
      apiKey: 'AIzaSyCHxxhPy86On1FtGfhl-tsr_reofhnbDBw',
      authDomain: 'bolt-mobile-log-viewer.firebaseapp.com',
      projectId: 'bolt-mobile-log-viewer',
      storageBucket: 'bolt-mobile-log-viewer.appspot.com',
      messagingSenderId: '592308029422',
      appId: '1:592308029422:web:51378f1eefb4ab007430ff',
      measurementId: 'G-80J9BGP4QK',
    };

    const app = initializeApp(firebaseConfig);
    this.activeFirebase = {
      app,
      analytics: getAnalytics(app),
    };

    setAnalyticsCollectionEnabled(this.activeFirebase.analytics, true);
    app.automaticDataCollectionEnabled = true;
  }

  private static deinit() {
    if (this.activeFirebase) {
      console.log('Deinit Firebase');

      deleteApp(this.activeFirebase.app);
      this.activeFirebase = undefined;
    }
  }

  static log(event: AnalyticsEvent, params: { [key: string]: any } | undefined = undefined) {
    const eventStr = AnalyticsEvent[event];

    if (process.env.NODE_ENV === 'development') {
      console.log('Analytics.log (dev-console-only)', eventStr, params);
      return;
    }

    if (this.disabled) {
      console.log('Analytics.log (disabled)', eventStr);
      return;
    }

    if (!this.activeFirebase) {
      this.init();
    }

    if (this.activeFirebase) {
      console.log('Analytics.log (enabled)', eventStr, params);
      logEvent(this.activeFirebase.analytics, eventStr, params);
    } else {
      console.warn('Cannot activate Firebase instance');
    }
  }

  static setDisabled(v: boolean) {
    this.disabled = v;

    if (this.disabled) {
      this.deinit();
    } else {
      this.init();
    }
  }
}
